import { render, staticRenderFns } from "./FieldList.vue?vue&type=template&id=32f3d068&scoped=true"
import script from "./FieldList.vue?vue&type=script&lang=js"
export * from "./FieldList.vue?vue&type=script&lang=js"
import style0 from "./FieldList.vue?vue&type=style&index=0&id=32f3d068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3d068",
  null
  
)

export default component.exports